import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LocalStorageService } from '../../../services/local-storage/local-storage.service';
import { Hilfe, HilfeDialogResult } from '../Hilfe';
import { HilfeService } from '../hilfe.service';
import { MessageService } from '../../../services/message-service/message.service';

@Component({
    selector: 'kiene-hilfe-button',
    templateUrl: './hilfe-button.component.html',
    styleUrls: ['./hilfe-button.component.scss'],
})
export class HilfeButtonComponent implements OnInit, OnDestroy {
    @Input() projekt: string;
    @Input() routeUrlOrKey: string; // für fixe Hilfe mit fixem Key an einer Stelle

    hilfe: Hilfe;
    hasCreateHelpPermission: boolean = false;
    private routerEventsSubscription: Subscription;
    private hilfeSub: Subscription;

    constructor(
        private hilfeService: HilfeService,
        private localStorageService: LocalStorageService,
        private router: Router,
        private messageService: MessageService,
    ) {}

    ngOnInit(): void {
        this.checkCreateHelpPermission();

        if (!this.routeUrlOrKey) {
            this.routerEventsSubscription = this.router.events.subscribe({
                next: event => {
                    if (event instanceof NavigationEnd) {
                        this.ladeHilfe(this.router.url);
                    }
                },
            });
        } else {
            this.ladeHilfe(this.routeUrlOrKey);
        }
    }

    ngOnDestroy() {
        if (this.routerEventsSubscription) {
            this.routerEventsSubscription.unsubscribe();
        }
        if (this.hilfeSub) {
            this.hilfeSub.unsubscribe();
        }
    }

    openHilfeDialog(): void {
        if (!this.hilfe) {
            this.hilfe = new Hilfe(this.projekt, this.routeUrlOrKey || this.router.url);
        }
        this.hilfeService.openHilfeDialog(this.hilfe).subscribe({
            next: (result: HilfeDialogResult) => {
                if (result?.hilfe) {
                    this.hilfe = result.hilfe;
                }
            },
        });
    }

    private ladeHilfe(route: string): void {
        this.hilfe = null;
        this.hilfeSub?.unsubscribe();
        this.hilfeSub = this.hilfeService.getHelpAvailable(route, this.projekt).subscribe({
            next: hilfe => {
                this.hilfe = hilfe;
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Laden der Hilfen!', err);
            },
        });
    }

    private checkCreateHelpPermission(): void {
        this.hasCreateHelpPermission = this.localStorageService.hasPermission(402);
    }
}
